import { useQuery } from "@tanstack/react-query";
import { getStoreBackstockLedger } from "services/auditService";
import { StoreBackstockLedgerModel } from "models";

export interface StoreBackstockLedgerRequest {
  storeId: string;
  startDate: string;
  endDate: string;
}

export const useAuditDashboardStoreBackstockLedger = (
  params: StoreBackstockLedgerRequest | null | undefined
) => {
  return useQuery<StoreBackstockLedgerModel>({
    queryKey: [
      "audit-dashboard",
      "store-backstock-ledger",
      params?.storeId,
      params?.startDate,
      params?.endDate,
    ],
    queryFn: async () => {
      const response = await getStoreBackstockLedger(
        params!.storeId,
        params!.startDate,
        params!.endDate
      );

      if (!response) {
        return StoreBackstockLedgerModel.fromServerData({
          store_id: params!.storeId,
          store_name: undefined,
          store_timezone: undefined,
          start_date: params!.startDate,
          end_date: params!.endDate,
          daily: [],
          details: [],
          overall: {
            report_date: "",
            opening_packs: 0,
            opening_tickets: 0,
            activated_to_backstock_packs: 0,
            activated_to_backstock_tickets: 0,
            moved_from_counter_packs: 0,
            moved_from_counter_tickets: 0,
            returned_to_counter_packs: 0,
            returned_to_counter_tickets: 0,
            returned_to_lottery_packs: 0,
            returned_to_lottery_tickets: 0,
            inventory_depletion_packs: 0,
            inventory_depletion_tickets: 0,
            closing_packs: 0,
            closing_tickets: 0,
            resolved_after_range_packs: 0,
            resolved_after_range_tickets: 0,
            counter_opening_packs: 0,
            counter_opening_tickets: 0,
            counter_activated_packs: 0,
            counter_activated_tickets: 0,
            counter_from_backstock_packs: 0,
            counter_from_backstock_tickets: 0,
            counter_to_backstock_packs: 0,
            counter_to_backstock_tickets: 0,
            counter_sold_out_packs: 0,
            counter_sold_out_tickets: 0,
            counter_closing_packs: 0,
            counter_closing_tickets: 0,
            counter_expected_sales_tickets: 0,
          },
        });
      }

      return StoreBackstockLedgerModel.fromServerData(response);
    },
    enabled: Boolean(params?.storeId && params?.startDate && params?.endDate),
  });
};
